module.exports = __webpack_public_path__ + "static/media/43news.5b25f39b.jpg";